import { Component, OnInit } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Chart } from 'chart.js';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { EvaluationService } from 'src/app/shared/services/evaluationservice/evaluation.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { CommonModule } from '@angular/common';
interface Evaluation {
  is_evaluation: any;
}
@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule]
})
export class MainComponent implements OnInit {
  public evaluations: any[] = [];
  public showSpinner = false;
  public user: any = [];

  public yearlyAveragePoints = 0;
  public monthlyAveragePoints = 0;
  public wariningPercentage = 0;
  public kpValuesAndDescription: any = [];
  selectedMode: any;
  datamode: any;
  userInfo: any;
  colormode: any;
  showPoints: any;

  filteredEvaluations: Evaluation[] = [];
  constructor(
    public evalService: EvaluationService,
    public router: Router,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,
  ) {
    this.showSpinner = true;
    this.getEvaluation();
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_detail();
  }

  ngOnInit(): void {
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
  }
  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }

  getEvaluation() {
    this.evalService.getEvaluation().then((value) => {
      this.showSpinner = false;
      this.evaluations = value.data.evaluations.filter((evaluation: Evaluation) => evaluation.is_evaluation == "1");
      if (this.evaluations && this.evaluations.length > 0) {
        this.kpValuesAndDescription = value.data.kps_list;
        const pm_points: any[] = [];
        let totalEntries = 0;
        let warnings = 0;
        this.evaluations.forEach((x: any) => {
          if (x.pm_points == null || x.pm_points == '' || x.pm_points == 'NaN') {
            x.pm_points = '0';
          }
          if (x.pm_points < 5) {
            warnings++;
          }
          totalEntries++;
          pm_points.push(x.pm_points);
        });
        const numericValues = pm_points.map(Number);
        const sum = numericValues.reduce((partial_sum, value) => partial_sum + value, 0);
        const percentageone = (sum / totalEntries) * 10;
        this.yearlyAveragePoints = Math.round(percentageone);
        const percentage = (this.evaluations[this.evaluations.length - 1].pm_points / 10) * 100;
        this.monthlyAveragePoints = Math.round(percentage);
        this.showPoints = this.monthlyAveragePoints / 10;
        const percentagetwo = (warnings / totalEntries) * 100
        this.wariningPercentage = Math.round(percentagetwo);
        const colors = [
          '#FFB700',
          '#28a745',
          '#333333',
          '#c3e6cb',
          '#dc3545',
          '#6c757d',
        ];

        /* large line chart */
        const chLine = document.getElementById('chLine');
        const chartData = {
          labels: ['Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug'],
          datasets: [
            {
              data: pm_points,
              backgroundColor: '#FFE9B2',
              borderColor: colors[0],
              borderWidth: 4,
              pointBackgroundColor: colors[0],
              fill: true
            },
          ],
        };

        if (chLine) {
          new Chart('chLine', {
            type: 'line',
            data: chartData,
            options: {
              maintainAspectRatio: false,
              scales: {
                yAxes: [
                  {
                    display: false,
                    ticks: {
                      min: 1,
                      max: 10,
                      stepSize: 1,
                      beginAtZero: false,
                    },
                  },
                ],
                xAxes: [
                  {
                    ticks: {
                      min: 1,
                      max: 10,
                      stepSize: 1,
                      beginAtZero: false,
                    },
                  },
                ],
              },

              legend: {
                display: false,
              },
            },
          });
        }
      }
    });

  }

  showdata(data: any) {
    this.router.navigate(['/evaluation-summary'], {
      queryParams: { data: JSON.stringify(data), kpValues: JSON.stringify(this.kpValuesAndDescription) },
      skipLocationChange: true,
    });
  }

  onSubmit(f: NgForm) {
    this.showSpinner = true;
    this.evaluations = [];
    this.evalService
      .getAllEvaluationsFilters(
        f.value.month,
        f.value.startdate,
        f.value.enddate
      )
      .then((value) => {
        this.showSpinner = false;
        this.evaluations = value.data;

      });
  }

  onReset() {
    this.showSpinner = true;
    this.getEvaluation();
  }

  getColorPoint(data: any) {
    if (data <= 3) {
      return '#FED7DA';
    }
    if (data > 3 && data <= 4) {
      return '#DAD4FF';
    }
    if (data > 4 && data <= 5) {
      return '#FFE9B2';
    }
    if (data > 5 && data < 9) {
      return '#B9D6FF';
    }
    if (data >= 9) {
      return '#84FF89';
    }
    return '';
  }
  getBackgroundPoint(data: any) {
    if (data <= 3) {
      return '#FFF4F5';
    }
    if (data > 3 && data <= 4) {
      return '#dad4ff';
    }
    if (data > 4 && data <= 5) {
      return '#faedcd';
    }
    if (data > 5 && data < 9) {
      return '#DBEAFF';
    }
    if (data >= 9) {
      return '#E2FFE3';
    }
    return '';
  }
  getBorderPoint(data: any) {
    if (data <= 3) {
      return '#FD7171';
    }
    if (data > 3 && data <= 4) {
      return '#6358A7';
    }

    if (data > 4 && data <= 5) {
      return '#FFB700';
    }
    if (data > 5 && data < 9) {
      return '#2180FF';
    }
    if (data >= 9) {
      return '#007505';
    }
    return '';
  }

  getPointRemarks(data: any) {
    if (data <= 3) {
      return 'Poor';
    }
    if (data > 3 && data <= 4) {
      return 'Below';
    }
    if (data > 4 && data <= 5) {
      return 'Normal';
    }
    if (data > 5 && data < 9) {
      return 'Good';
    }
    if (data >= 9) {
      return 'Excellent';
    }
    return '';
  }
  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }
}
